<template>
  <div class="user">
    <div class="content">
      <div class="sidebar">
        <a href="#profile">基本信息</a>
        <a href="#password">密码修改</a>
        <a href="#footprints">足迹</a>
        <a href="#downloads">下载记录</a>
        <!-- <a href="#online-stats">在线时长统计</a> -->
        <a href="#bookshelf" class="active">我的书架</a>
      </div>
      <div class="main-content">
        <!-- 主要内容区域 -->
        <div id="profile">
          <p>基本信息</p>
          <div class="profile-block">
            <div class="label">用户名</div>
            <input v-model="profile.username" disabled/>
          </div>
          <!-- <div class="profile-block">
            <div class="label">邮箱</div>
            <input v-model="profile.email" class="email-input"/>
          </div> -->
          <div class="profile-block">
          </div>
        </div>
        <div id="password">
          <p>密码修改</p>
          <div class="profile-block">
            <div class="label">旧密码</div>
            <input v-model="passwordForm.old" class="password-input" type="password"/>
          </div> 
          <div class="profile-block">
            <div class="label">新密码</div>
            <input v-model="passwordForm.new1" class="password-input" type="password"/>
          </div>
          <div class="profile-block">
            <div class="label">再次输入新密码</div>
            <input v-model="passwordForm.new2" class="password-input" type="password"/>
          </div>
          <div class="profile-block">
            <LoadingButton class="m-button" style="color: white;" :buttonText="'确认修改'" :loading="loading" @button-click="changePassword"></LoadingButton>
          </div>
        </div>
        <div id="footprints">
          <p>足迹</p>
          <div class="profile-block">
            <BookShelf v-if="history.length > 0" :bookList="history"></BookShelf>
            <span v-else class="label">暂无足迹</span>
          </div>
        </div>
        <div id="downloads">
          <p>下载记录</p>
          <div class="profile-block">
            <BookShelf v-if="download.length > 0" :bookList="download"></BookShelf>
            <span v-else class="label">暂无下载记录</span>
          </div>
        </div>
        <!-- <div id="online-stats">
          <p>在线时长统计</p>
          <div class="profile-block">
            <span class="label">总计在线时长为 {{ profile.time }}</span>
          </div>
        </div> -->
        <div id="bookshelf">
          <p>我的书架</p>
          <div class="profile-block">
            <BookShelf v-if="shelf.length > 0" :bookList="shelf"></BookShelf>
            <span v-else class="label">暂无收藏记录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUser, changePassword } from '@/_api/login'
import { getReaderHistory, getReaderDownload, getReaderShelf } from '@/_api/reader.js'

export default {
  name: 'HomeView',
  data() {
    return {
      profile: {},
      history: [],
      download: [],
      shelf: [],
      passwordForm: {},
      size: 10,
      page: 1,
      loading: false
    }
  },
  mounted() {
    this.getUserInfo()
    this.getUserHistory()
    this.getUserDownload()
    this.getUserShelf()
  },
  methods: {
    getUserShelf() {
      getReaderShelf({
        size: 30,
        page: this.page
      }).then((res) => {
        if (res.status == 'ok') {
          this.shelf = res.data.userShelves
          for(let i = 0; i < this.shelf.length ; i++) {
            this.shelf[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.shelf[i].coverUrl
          }
        }
      })
    },
    getUserDownload() {
      getReaderDownload({
        size: 30,
        page: this.page
      }).then((res) => {
        if (res.status == 'ok') {
          this.download = res.data
          for(let i = 0; i < this.download.length ; i++) {
            this.download[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.download[i].coverUrl
          }
        }
      })
    },
    getUserHistory() {
      getReaderHistory({
        size: 30,
        page: this.page
      }).then((res) => {
        if (res.status == 'ok') {
          this.history = res.data
          for(let i = 0; i < this.history.length ; i++) {
            this.history[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.history[i].coverUrl
          }
        }
      })
    },
    getUserInfo() {
      getUser().then((res) => {
        if (res.status == 'ok') {
          this.profile = res
        }
      })
    },
    changePassword() {
      this.loading = true
      const { old, new1, new2 } = this.passwordForm;

      if (new1 !== new2) {
        this.$message.error('新密码不一致，请重新输入');
        return;
      }

      changePassword({ 
        password: new1,
        oldPassword: old
      }).then(res => {
        if (res.code == 1005) {
          this.$message.error("原密码不正确")
        }
        else if (res.status == 'ok') {
          this.$message.success('修改成功');
          this.passwordForm = {}
        }
      })
      .catch(error => {
        // 处理请求错误
        console.error('修改密码请求错误:', error);
        this.$message.error('密码修改失败，请稍后重试');
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="less">
.user {
  margin: 0;
  flex: 1;
  background-color: white;

  .content {
    width: 90vw;
    margin: 50px auto;
    display: flex;
    @media screen and (max-width:700px) {
      flex-direction: column;
    }
  }


  .sidebar {
    width: 200px;
    background-color: transparent;
    color: black;
    font-size: 15px;
    @media screen and (max-width:700px) {
      width: 100%;
    }
  }

  .sidebar a {
    text-decoration: none;
    color: black;
    padding: 10px;
    display: block;

    &:hover {
      background-color: rgba(242, 242, 242, 0.618);
      border-radius: 6px;
    }

    &:active {
      font-weight: 700;
    }
  }

  .main-content {
    margin-left: 30px;
    width: calc(100% - 200px);
    @media screen and (max-width:700px) {
      width: 100%;
      margin: 30px 0 0 0;
    }
    p {
      width: 100%;
      border-bottom: 3px solid rgba(242, 242, 242, 0.618);
      padding-bottom: 8px;
      font-weight: 400;
      font-size: 26px;
    }
    .profile-block {
      margin-top: 20px;
      .label {
        color: var(--paragraph);
        font-weight: 800;
      }
      input {
        margin-top: 5px;
      }
      .email-input {
        width: 50%;
        min-width: 200px;
      }
      .password-input {
        width: 45%;
        min-width: 170px;
      }
      .m-button {
        color: #FFFFFF;
        font-weight: 400;
        font-size: 15px;
        letter-spacing: 2px;
        border-radius: 4px;
      }
    }
  }

  #password {
    margin-top: 50px;
  }

  #footprints {
    margin-top: 50px;
  }

  #downloads {
    margin-top: 50px;
  }

  #online-stats {
    margin-top: 50px;
  }

  #bookshelf {
    margin-top: 50px;
  }
}
</style>